import { render, staticRenderFns } from "./UpdateSpecimenLocation.vue?vue&type=template&id=005f5a2b"
import script from "./UpdateSpecimenLocation.vue?vue&type=script&lang=js"
export * from "./UpdateSpecimenLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports